module.exports = __webpack_public_path__ + "static/media/horse-playing-football.623b4cfe.png";